import React from 'react';
import QuickSection from '../components/atoms/QuickSection';

const QuickAction = () => {
  return (
    <>
   
      <QuickSection />
    </>
  );
};

export default QuickAction;
